import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './globals.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {createRoot} from 'react-dom/client';

import { createStore } from 'redux';
import { Provider } from 'react-redux';
import allReducers from './redux/reducers/index'

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast';

const store = createStore(
  allReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
const basename = document.querySelector('base')?.getAttribute('href') ?? '/'    

const root = createRoot(document.getElementById("root"));

const queryClient = new QueryClient()

root.render(
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      {   ReactSession.setStoreType("localStorage") }
      {   ReactSession.set("language", "N") }
      <QueryClientProvider client={queryClient}>
        <Toaster />
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
